import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=0d7325b4&scoped=true&"
import script from "./auth.js?vue&type=script&lang=js&"
export * from "./auth.js?vue&type=script&lang=js&"
import style0 from "./auth.scss?vue&type=style&index=0&id=0d7325b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7325b4",
  null
  
)

export default component.exports